import { css } from '@emotion/react';
import { Box, styled } from '@mui/joy';

import { transientOptions } from '@/utils/transient-options';

export const TableWrapper = styled(
  Box,
  transientOptions,
)<{ $fullHeight?: boolean; $adminLevelBreadCrumbVisible?: boolean }>(
  ({ theme, $fullHeight, $adminLevelBreadCrumbVisible }) => css`
    display: flex;
    flex-direction: column;

    ${
      $fullHeight &&
      css`
        flex: 1;
        max-height: calc(100vh - ${theme.spacing(25)} - ${$adminLevelBreadCrumbVisible ? theme.spacing(5) : '0px'});
      `
    }
  `,
);
